import api from "./api";
import auth from "./auth";

const LIST = (page = 1, search = null) => {
    return new Promise((resolve, reject) => {
        api.post("employee-auth-service/v2/list/" + page, search, auth.getHeader())
            .then(response => resolve(response))
            .catch(e => reject(e.errors));
    });
};

const CREATE = payload => {
    return new Promise((resolve, reject) => {
        api.post("employee-auth-service/v2/create", payload, auth.getHeader())
            .then(response => resolve(response))
            .catch(e => reject(e.errors));
    });
};

const UPDATE = payload => {
    return new Promise((resolve, reject) => {
        api.post(
            "employee-auth-service/v2/update",
            payload,
            auth.getHeader()
        )
            .then(response => resolve(response))
            .catch(e => reject(e.errors));
    });
};

const VIEW = id => {
    return new Promise((resolve, reject) => {
        api.get("employee-auth-service/view/" + id, auth.getHeader())
            .then(response => resolve(response))
            .catch(e => reject(e.errors));
    });
};

const DELETE = id => {
    return new Promise((resolve, reject) => {
        api.delete("employee-auth-service/delete/" + id, auth.getHeader())
            .then(response => resolve(response))
            .catch(e => reject(e.errors));
    });
};

const BULKIMPORTEMPLOYEES = (payload) => {
    return new Promise((resolve, reject) => {
        api.post(
            `employee-auth-service/batch/employee/upload`,
            payload,
            auth.getHeader()
        )
            .then(response => resolve(response))
            .catch((status, errors) => reject(status, errors));
    });
};

const UPDATE_MMA_AUTO_LOGOUT_SETTINGS = (payload) => {
  return new Promise((resolve, reject) => {
    api.post(
      `employee-auth-service/cms/session-settings/save`,
      payload,
      auth.getHeader()
    )
      .then(response => resolve(response))
      .catch((status, errors) => reject(status, errors));
  });
};

const GET_MMA_AUTO_LOGOUT_SETTINGS = () => {
  return new Promise((resolve, reject) => {
    api.get(
      `employee-auth-service/cms/session-settings/details`,
      auth.getHeader()
    )
      .then(response => resolve(response))
      .catch((status, errors) => reject(status, errors));
  });
};

export default {
    getList: LIST,
    create: CREATE,
    update: UPDATE,
    view: VIEW,
    delete: DELETE,
    bulkImportEmployees: BULKIMPORTEMPLOYEES,
    updateMmaAutoLogoutSettings: UPDATE_MMA_AUTO_LOGOUT_SETTINGS,
    getMmaAutoLogoutSettings: GET_MMA_AUTO_LOGOUT_SETTINGS
};
